<main>
    <!-- Banner -->
    <div class="breadcrumb__area breadcrumb__overlay breadcrumb__height p-relative fix"
      data-background="assets/img/breadcurmb/breadcurmb.jpg"
      style="background-image: url(assets/images/breadcurmb/joy_refer.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-xxl-12">
            <div class="breadcrumb__content z-index text-center">
              <h3 class="breadcrumb__title"> </h3>
              <div class="breadcrumb__list">
                <span><a class="no-underline" routerLink="/index">Home</a></span>
                <!-- <span class="dvdr"><i class="fa fa-angle-right"></i></span>
                <span>MOMents that matter</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Banner End -->

    <!-- Mother Event -->
      <!-- <div class="container py-5">
        <div class="row g-3 mb-4">
          <div class="col-md-4">
            <button class="btn btn-outline-primary w-100" (click)="toggleSection('document')">
              Selfie
            </button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-outline-success w-100" (click)="toggleSection('text')">
              Note
            </button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-outline-warning w-100" (click)="redirectAction()">
              Do not want to Participate
            </button>
          </div>
        </div>

        <div *ngIf="openSection === 'document'" class="card p-4 mb-3">
          <h5 class="mb-3">Capture Selfie</h5>
          <button class="btn btn-primary w-100 mb-2" (click)="openCamera()">Open Camera</button>
          <video #videoElement width="100%" height="auto" autoplay></video>
          <canvas #canvasElement style="display:none;"></canvas>
          <button class="btn btn-success w-100 mt-3" (click)="captureImage()">Capture Image</button>
          <img *ngIf="capturedImage" [src]="capturedImage" alt="Captured Image" style="width: 100%; margin-top: 10px;">
          <br />

          <input type="file" (change)="uploadFromFolder($event)" class="form-control" />
          <button class="btn btn-secondary w-100 mt-3" (click)="uploadDocument()">Submit</button>
        </div>

        <div *ngIf="openSection === 'text'" class="card p-4 mb-3">
          <h5 class="mb-3">Note Upload</h5>
          <textarea [(ngModel)]="textInput" class="form-control mb-3" placeholder="Write your text here..."></textarea>
          <button class="btn btn-success w-100" (click)="uploadText()"><i class="fa fa-upload"></i> Submit</button>
        </div>

      </div> -->
        <!-- Redirect  -->
        <!-- <div *ngIf="openSection === 'redirect'" class="card p-4 mb-3">
          <h5 class="mb-3">Voucher Page</h5>
          <button class="btn btn-warning w-100" (click)="redirectAction()">Go to Page</button>
        </div> -->
    <!-- Mother Event End -->

    <!-- Father Event -->
      <!-- <div class="container py-5">
        <div class="row g-4">
          <div class="d-flex justify-content-center">
            Skip Card
            <div class="col-md-4" style="padding-right: 2%;">
              <div class="card h-100 text-center shadow-sm border headings" (click)="redirectAction()" style="cursor: pointer;">
                <div class="card-body">
                  <i class="fa fa-gift fa-3x text-warning mb-2"></i>
                  <h5 class="card-title">Claim only primary voucher</h5>
                </div>
              </div>
            </div>

            Selfie Card
            <div class="col-md-4">
              <div class="card h-100 text-center shadow-sm border headings" (click)="toggleSection('document')" style="cursor: pointer;">
                <div class="card-body">
                  <i class="fa fa-camera fa-2x text-primary mb-2"></i>
                  <h5 class="card-title">Capture Video Message</h5>
                </div>
              </div>
            </div>
          </div>

          Note Card
          <div class="col-md-4">
            <div class="card h-100 text-center shadow-sm border headings" (click)="toggleSection('text')" style="cursor: pointer;">
              <div class="card-body">
                <i class="fa fa-pencil fa-2x text-success mb-2"></i>
                <h5 class="card-title">Write a Note</h5>
              </div>
            </div>
          </div>


        </div>

        Toggle Section: Video
        <div *ngIf="openSection === 'document'" class="card mt-4 p-4 shadow-sm bodies" id="divSelfie">
          <h5 class="text-primary mb-3"><i class="fa fa-camera me-2"></i>Capture Video</h5>

          accept only video
          <input type="file" accept="video/*" (change)="uploadFromFolder($event)" class="form-control mt-2" />

          <button class="btn btn-secondary w-100 mt-3" style="background-color: #ed1d24; color: #fff;" (click)="uploadDocument()" [disabled]="isUploading">
            <ng-container *ngIf="!isUploading"><i class="fa fa-upload me-1"></i> Submit</ng-container>
            <ng-container *ngIf="isUploading">
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Uploading...
            </ng-container>
          </button>
        </div>

        Toggle Section: Selfie
        <div *ngIf="openSection === 'document'" class="card mt-4 p-4 shadow-sm bodies" id="divSelfie">
          <h5 class="text-primary mb-3"><i class="fa fa-camera me-2"></i>Capture Selfie</h5>
          <input type="file" (change)="uploadFromFolder($event)" class="form-control mt-2" />
          <button class="btn btn-secondary w-100 mt-3" style="background-color:  #ed1d24; color: #fff;" (click)="uploadDocument()"><i class="fa fa-upload me-1"></i> Submit</button>
        </div>

        Toggle Section: Note
        <div *ngIf="openSection === 'text'" class="card mt-4 p-4 shadow-sm bodies" id="divNote">
          <h5 class="text-success mb-3"><i class="fa fa-pencil-alt me-2"></i>Note</h5>
          <textarea [(ngModel)]="textInput" class="form-control mb-3" rows="5" placeholder="Write your note here..."></textarea>
          <button class="btn btn-success w-100" style="background-color:  #ed1d24; color: #fff;" (click)="uploadText()"><i class="fa fa-upload me-1"></i> Submit</button>
        </div>
      </div> -->
    <!-- Father Event End -->




    <!-- New Event Section -->
      <div class="container py-5">
        <div class="row g-4">
          <div class="d-flex justify-content-center">
            <!-- Skip Card -->
            <div class="col-md-4" style="padding-right: 2%;">
              <div class="card h-100 text-center shadow-sm border headings" (click)="togglestep('redirect')" style="cursor: pointer;">
                <div class="card-body">
                  <i class="fa fa-gift fa-3x text-warning mb-2"></i>
                  <h5 class="card-title">Click Here to Refer</h5>
                </div>
              </div>
            </div>
          </div>

            <div *ngIf="openSection === 'redirect'" class="form-wrapper">

              <!-- Step 1: Mobile Verification -->
              <div *ngIf="currentStep === 'step1'" class="form-card">
                <h5 class="section-title">Enter Mobile Number<span class="text-danger">*</span></h5>
                <!-- <input type="text" class="form-input" placeholder="Enter Mobile Number" [(ngModel)]="mobileNumber"
                  (keypress)="allowOnlyNumbers($event)" maxlength="10" [readonly]="mobileVerified">
                <button class="btn btn-primary full-width" (click)="verifyMobile()" [disabled]="mobileVerified">Check</button> -->
                <input type="tel" minlength="10" maxlength="10" class="form-input" id="mobileInput" placeholder="Enter Mobile Number" [(ngModel)]="mobileNumber" (ngModelChange)="filterNumberOnly($event)"
                  [readonly]="mobileVerified">
                <button class="btn btn-primary full-width" (click)="verifyMobile()" [disabled]="mobileVerified">Check</button>
              </div>

              <!-- Step 2: Firm Details -->
              <div *ngIf="currentStep === 'step2'" class="form-card">
                <h5 class="section-title">Mobile Number:-</h5>
                <input type="text" class="form-input" [value]="mobileNumber" readonly>

                <hr>
                <!-- <h5 class="section-title mt-4">Enter Firm Details:-</h5> -->
                <label>Name<span class="text-danger">*</span></label>&nbsp;
                <input type="text" class="form-input" placeholder="Referral Name" [(ngModel)]="refName" [readonly]="firmDetailsValid" (keypress)="allowAlphaNumeric($event)">

                <label>Firm Name<span class="text-danger">*</span></label>&nbsp;
                <input type="text" class="form-input" placeholder="Firm Name" [(ngModel)]="firm_name" [readonly]="firmDetailsValid" (keypress)="allowAlphaNumeric($event)">

                <div class="form-group">
                  <label>State<span class="text-danger">*</span></label>&nbsp;
                  <ngx-select-dropdown [config]="StatedropdownConfig" [options]="dropdownoptionState" (change)="onStateChange($event)"> </ngx-select-dropdown>

                  <!-- <select id="stateDropdown" class="form-input" [(ngModel)]="selectedState" (change)="onStateChange(selectedState)">
                    <option value="" disabled selected *ngIf="!selectedState">Select State</option>
                    <option *ngFor="let state of statesAndCities" [value]="state.StateID">{{ state.StateName }}</option>
                  </select> -->
                </div>

                <!-- <div class="form-group">
                  <label>State<span class="text-danger">*</span></label>&nbsp;
                  <div class="dropdown">
                    <select id="stateDropdown" class="form-input" [(ngModel)]="selectedState" (change)="onStateChange(selectedState)" (click)="toggleDropdown($event)">
                      <option value="" disabled selected *ngIf="!selectedState">Select State</option>
                      <option *ngFor="let state of filteredStates" [value]="state.StateID">{{ state.StateName }}</option>
                    </select>

                    <div *ngIf="isDropdownOpen" class="custom-dropdown">
                      <input type="text" class="search-input" placeholder="Search State" (input)="filterStates($event)"/>
                      <ul class="dropdown-list">
                        <li *ngFor="let state of filteredStates" (click)="selectState(state)">
                          {{ state.StateName }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> -->


                <div class="form-group">
                  <label>City<span class="text-danger">*</span></label>&nbsp;
                  <ngx-select-dropdown [config]="CityropdownConfig" [options]="dropdownoptionCity" > </ngx-select-dropdown>
                  <!-- <select id="cityDropdown" class="form-input" placeholder="City" [(ngModel)]="selectedCity" [disabled]="!cities.length">
                    <option value="" disabled selected *ngIf="!selectedCity">Select City</option>
                    <option *ngFor="let city of cities" [value]="city.CityID">{{ city.CityName }}</option>
                  </select> -->
                </div>
                <!-- <label>State<span class="text-danger">*</span></label>&nbsp;
                <input type="text" class="form-input" placeholder="State" [(ngModel)]="state" [readonly]="firmDetailsValid">

                <label>City<span class="text-danger">*</span></label>&nbsp;
                <input type="text" class="form-input" placeholder="City" [(ngModel)]="city" [readonly]="firmDetailsValid"> -->

                <!-- <button class="btn btn-primary full-width mt-3" *ngIf="!firmDetailsValid" (click)="validateFirmDetails()" [disabled]="firmDetailsValid">Validate</button> -->
                <button class="btn btn-success full-width mt-2" (click)="submitFirmDetails()">Submit</button>
              </div>

            </div>

        </div>
      </div>
    <!-- New Event Section End -->






</main>
